var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatsLite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 25"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "stats-lite_svg__a",
  width: 24,
  height: 25,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 .119h24v24H0z"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#stats-lite_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "stats-lite_svg__b",
  width: 24,
  height: 25,
  x: 0,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 1.119h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#stats-lite_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.73 17.62h1v-6h-1zm3.77 0h1v-9h-1zm3.77 0h1v-3h-1zm-9.655 3.5q-.69 0-1.152-.463A1.57 1.57 0 0 1 4 19.504V6.734q0-.69.463-1.152a1.57 1.57 0 0 1 1.152-.463h12.77q.69 0 1.152.463.463.462.463 1.153v12.769q0 .69-.462 1.153a1.56 1.56 0 0 1-1.153.462zm0-1h12.77a.59.59 0 0 0 .423-.193.59.59 0 0 0 .192-.423V6.734a.59.59 0 0 0-.192-.423.59.59 0 0 0-.423-.192H5.615a.59.59 0 0 0-.423.192.59.59 0 0 0-.192.424v12.769q0 .231.192.423.194.192.423.192"
})))));
export default SvgStatsLite;